module.exports = __webpack_public_path__ + "static/media/house.176258da.svg";